// Codice creator dell'utente loggato: se attivo, i link condivisi e la barra degli indirizzi portano ?ref=CODICE
import { useEffect, useState } from "react";

const KEY = "creator_code";
const EVENTO = "creator-code-changed";

export function setCreatorCode(code) {
  try { code ? localStorage.setItem(KEY, code) : localStorage.removeItem(KEY); } catch {}
  window.dispatchEvent(new Event(EVENTO));
}

export function getCreatorCode() {
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
}

// Hook reattivo: i componenti che lo usano si aggiornano appena il codice cambia (login/logout)
export function useCreatorCode() {
  const [code, setCode] = useState(getCreatorCode());
  useEffect(() => {
    const h = () => setCode(getCreatorCode());
    window.addEventListener(EVENTO, h);
    return () => window.removeEventListener(EVENTO, h);
  }, []);
  return code;
}

// Aggiunge ?ref=CODICE a un URL (o path) se l'utente loggato è un creator
export function withRef(url) {
  const c = getCreatorCode();
  if (!c || /[?&]ref=/.test(url)) return url;
  return url + (url.includes("?") ? "&" : "?") + "ref=" + encodeURIComponent(c);
}
